import BaseDocument from './BaseDocument';

class UserVariants extends BaseDocument {
}

export default UserVariants;
